import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select from 'react-select';

import EditButton from "../EditButton";
import { Enumeration, PropertyContent } from "../../utils/interface";
import { formatEnumsForDropDown } from "../../utils/helperFunction";

interface EditPropertyContentModalFormProps {
  propertyContentTypes: Enumeration[];
  propertyContent: PropertyContent;
  onUpdatePropertyContent: (propertyContent: any) => void;
}

const EditPropertyContentModalForm: React.FC<EditPropertyContentModalFormProps> = ({
  propertyContentTypes,
  propertyContent,
  onUpdatePropertyContent,
}) => {
  const [propertyContentInfo, setPropertyContentInfo] = useState(propertyContent);
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const handleSave = (propertyContent: any) => {
    onUpdatePropertyContent(propertyContent);
    handleClose();
  };

  useEffect(() => {
    setPropertyContentInfo(propertyContent);
  }, [propertyContent])

  return (<>
    <EditButton onClick={handleShow} />
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update Content</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="content-id">
            <Form.Label>#ID</Form.Label>
            <Form.Control
              type="text"
              value={propertyContentInfo.propertyContentId}
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="content-type">
            <Form.Label>Type</Form.Label>
            <Select
              options={formatEnumsForDropDown(propertyContentTypes)}
              isSearchable
              placeholder=""
              value={
                formatEnumsForDropDown(propertyContentTypes)
                  .find(it => it.value === propertyContentInfo.propertyContentTypeEnumId)
              }
              onChange={(selectedOption) => {
                if (selectedOption) {
                  setPropertyContentInfo({ ...propertyContentInfo, propertyContentTypeEnumId: selectedOption.value })
                }
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="content-seq-num">
            <Form.Label>#Seq</Form.Label>
            <Form.Control
              type="number"
              value={propertyContentInfo.sequenceNum}
              onChange={(e) => setPropertyContentInfo({ ...propertyContentInfo, sequenceNum: parseInt(e.target.value) })}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
        <Button variant="primary" onClick={() => handleSave(propertyContentInfo)}>Save</Button>
      </Modal.Footer>
    </Modal>
  </>);
};

export default EditPropertyContentModalForm;
